import "./translate.css";

const Translate = () => {
  return (
    <div className="left-side-translate">
      {" "}
      <h4>Translate</h4>
    </div>
  );
};

export default Translate;
